import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDeliveryProfileProductCount = {
  name: "getDeliveryProfileProductCount" as const,
  input: z.object({ teamId: zExt.objectId(), deliveryProfileId: z.number() }),
  output: z.object({
    productCount: z.number(),
    deliveryProfileName: z.string().nullable(),
  }),
};
